import { render } from "./KSClusterPageWaiter.vue?vue&type=template&id=ffc32da0&scoped=true"
import script from "./KSClusterPageWaiter.vue?vue&type=script&lang=js"
export * from "./KSClusterPageWaiter.vue?vue&type=script&lang=js"

import "./KSClusterPageWaiter.vue?vue&type=style&index=0&id=ffc32da0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffc32da0"]])

export default __exports__